// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/sourceContribution',
    name: 'SourceContribution',
    component: layout,
    redirect: '/sourceContribution/index',
    meta: {
      title: '信源贡献分析',
      i18Key: 'router.user.sourceContribution.title',
      roles: [1],
      category: 'optimize'
    },
    sort: 30,
    children: [
      {
        path: 'index',
        name: 'SourceContributionIndex',
        component: () => import('@/views/SourceContribution/Index.vue'),
        meta: {
          title: '信源贡献分析',
          i18Key: 'router.user.sourceContribution.index',
          roles: [1],
          headerConditions: ['brand']
        }
      }
    ]
  }
]
export default routes
